<!--
  Cartão único, redação variável. A ordem dos ramos é a regra de negócio: "padronização em andamento" é um
  caso ESPECÍFICO de "documento enviado e nada validado" e vem primeiro — quem acabou de subir arquivo no
  Data Room precisa saber que a IA está trabalhando, não ser mandado conferir uma tela que ainda está vazia
  para ele. Usado também pela Modelagem DFP.

  `ignore-export` só nos botões: a mensagem explica um PDF/Excel vazio e merece sair no relatório; um botão
  de navegação, não.
-->
<div
  class="dfp-empty-state"
  [class.dfp-empty-state--no-data]="!statusUnavailable"
  [class.dfp-empty-state--pending]="!progressResolved() && !statusUnavailable">
  <div class="dfp-empty-state__icon-title"></div>

  @if (!progressResolved() && !statusUnavailable) {
    <!--
      Resumo ainda não respondeu: nenhuma redação é escolhida aqui. Sem este gate, `progress()` nulo cai no
      ramo por documento enviado e a empresa que está EXTRAINDO pode receber "Nenhum documento contábil
      enviado" com atalho para o Data Room — mandando o usuário reenviar o que já está sendo processado.
    -->
  } @else if (progress()?.isProcessing) {
    <h4>Estamos padronizando seus documentos</h4>
    <p>
      Encontramos documentos em padronização para esta empresa. Esse processo leva de
      <strong>5 a 10 minutos</strong>. Pode deixar esta tela aberta: os dados aparecem aqui sozinhos
      quando estiverem prontos.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        label="Verificar agora"
        icon="pi pi-refresh"
        [fitContent]="true"
        [isLoading]="isChecking()"
        loadingText="Verificando..."
        [disabled]="isChecking()"
        (sendClick)="checkNow()" />
    </div>
  } @else if (statusUnavailable) {
    <h4>A DRE e o Balanço cadastrados estão em avaliação pela nossa equipe</h4>
    <p>Os dados aparecem nesta página assim que a avaliação terminar.</p>
    <p>
      <span class="dfp-empty-state__icon-alert"> </span>Lembre-se de manter os documentos em dia
      para visualizar dados atualizados.
    </p>
  } @else if (hasSentDocuments() === false) {
    <h4>Nenhum documento contábil enviado</h4>
    @if (canOpenDataRoom()) {
      <p>
        Envie a DRE e o Balanço no <strong>Data Room</strong> da empresa. Eles são lidos pelo Cog e,
        depois de validados, aparecem aqui.
      </p>
    } @else {
      <p>
        Peça a quem administra a empresa para enviar a DRE e o Balanço pelo Data Room. Depois de
        lidos e validados, eles aparecem aqui.
      </p>
    }
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        *appHasPermission="dataRoomPermission"
        label="Ir para o Data Room"
        icon="pi pi-arrow-right"
        iconPosition="right"
        [fitContent]="true"
        (sendClick)="goToDataRoom()" />
    </div>
  } @else if (hasSentDocuments() === true) {
    <h4>Os documentos desta empresa ainda não têm dados validados</h4>
    <p>
      Há documentos enviados, mas nenhum com a extração revisada e validada. A validação é que
      libera os números para esta tela: confira em <strong>Padronização de dados contábeis</strong>.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        *appHasPermission="standardizationPermission"
        label="Verificar"
        icon="pi pi-arrow-right"
        iconPosition="right"
        [fitContent]="true"
        (sendClick)="goToStandardization()" />
    </div>
  } @else {
    <h4>Esta empresa não possui dados extraídos validados</h4>
    <p>
      Confira o andamento em <strong>Padronização de dados contábeis</strong>. Lá os documentos são
      extraídos pelo Cog, revisados e validados antes de alimentarem esta tela.
    </p>
    <div class="dfp-empty-state__action ignore-export">
      <app-button
        *appHasPermission="standardizationPermission"
        label="Verificar"
        icon="pi pi-arrow-right"
        iconPosition="right"
        [fitContent]="true"
        (sendClick)="goToStandardization()" />
    </div>
  }
</div>
